import React, { useState, useEffect } from 'react';
import { Plug, Wrench, Clock, CreditCard } from 'lucide-react';
import "../../../../assets/css/subscreens/customer/home/how it works/HowItWorks.css";

const HowItWorks = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const steps = [
    { number: '01', title: 'Select Service', description: 'Choose from services...', icon: <Plug size={32} /> },
    { number: '02', title: 'Book Service', description: 'Pick your date/time...', icon: <Wrench size={32} /> },
    { number: '03', title: 'Professional Arrives', description: 'Verified professional arrives...', icon: <Clock size={32} /> },
    { number: '04', title: 'Pay & Review', description: 'Make secure payment...', icon: <CreditCard size={32} /> }
  ];

  return (
    <section className="simple-hiw-section">
      <div className="simple-hiw-container">
        <div className={`simple-hiw-header ${isVisible ? 'simple-fade-in' : ''}`}>
          <span className="simple-hiw-label">HOW IT WORKS</span>
          <h2 className="simple-hiw-title">Simple Steps to Quality Service</h2>
          <p className="simple-hiw-subtitle">Get professional home services in just a few clicks</p>
        </div>

        <div className="simple-hiw-steps">
          {steps.map((step, index) => (
            <div key={index} className={`simple-step-item ${isVisible ? 'simple-slide-in' : ''}`} style={{ transitionDelay: `${index * 0.2}s`, textAlign: 'center' }}>
              <div className="simple-step-icon" style={{ marginBottom: '10px' }}>{step.icon}</div>
              <h3 className="simple-step-title">{step.title}</h3>
              <p className="simple-step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;